import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { EditRubricComposableSection } from 'apps/sigma2-ui/src/components/rubrics/EditRubricComposableSection';
import { EditableRubricCategoryWithError } from 'libs/end-to-end/src/types/rubrics/rubric';
import { RubricGradingType } from 'libs/end-to-end/src/types/rubrics/rubric';
import { EditRubricPreviewCategorySection } from 'apps/sigma2-ui/src/components/rubrics/EditRubricPreviewCategorySection';
import { EditRubricEditCategorySection } from 'apps/sigma2-ui/src/components/rubrics/EditRubricEditCategorySection';

const EditRubricCategoriesAndCriteriaSectionIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
    >
      <rect width="72" height="72" rx="20" fill="#080857" />
      <rect width="72" height="72" rx="20" fill="#080857" />
      <path
        d="M48.5156 21.5996C48.8029 21.5996 49.0872 21.6567 49.3525 21.7666C49.6179 21.8765 49.8594 22.0371 50.0625 22.2402C50.2656 22.4434 50.4272 22.6848 50.5371 22.9502C50.647 23.2155 50.7031 23.5 50.7031 23.7871V48.1621C50.6998 48.7413 50.4681 49.2965 50.0586 49.7061C49.6491 50.1153 49.0946 50.3463 48.5156 50.3496H22.8906C22.3116 50.3463 21.7571 50.1154 21.3477 49.7061C20.9381 49.2965 20.7064 48.7413 20.7031 48.1621V23.7871C20.7032 23.207 20.9335 22.6504 21.3438 22.2402C21.754 21.83 22.3105 21.5996 22.8906 21.5996H48.5156ZM31.6406 48.4746H48.5156C48.5983 48.4746 48.6778 48.4422 48.7363 48.3838C48.7949 48.3252 48.8281 48.245 48.8281 48.1621V23.7871C48.8281 23.7043 48.7949 23.625 48.7363 23.5664C48.6777 23.5079 48.5985 23.4746 48.5156 23.4746H31.6406V48.4746ZM43.8613 45.0254C44.1099 45.0255 44.3487 45.1241 44.5244 45.2998C44.7001 45.4756 44.7988 45.7143 44.7988 45.9629C44.7988 46.2114 44.7001 46.4502 44.5244 46.626C44.3487 46.8017 44.1099 46.9003 43.8613 46.9004H36.7109C36.4623 46.9004 36.2236 46.8018 36.0479 46.626C35.8721 46.4502 35.7734 46.2115 35.7734 45.9629C35.7735 45.7143 35.8721 45.4756 36.0479 45.2998C36.2236 45.124 36.4623 45.0254 36.7109 45.0254H43.8613ZM43.2773 38.1641C43.2773 38.1641 44.5273 38.1642 44.5273 39.4141V41.2891C44.5273 41.2891 44.5273 42.5391 43.2773 42.5391H37.29C37.2778 42.539 36.04 42.5329 36.04 41.2891V39.4141C36.0401 39.4013 36.0466 38.1641 37.29 38.1641H43.2773ZM24.7656 38.4746C24.517 38.4746 24.2783 38.5733 24.1025 38.749C23.9268 38.9248 23.8282 39.1635 23.8281 39.4121C23.8281 39.6607 23.9268 39.8994 24.1025 40.0752C24.2783 40.251 24.517 40.3496 24.7656 40.3496H28.5156C28.7643 40.3496 29.0029 40.251 29.1787 40.0752C29.3545 39.8994 29.4531 39.6607 29.4531 39.4121C29.4531 39.1635 29.3545 38.9248 29.1787 38.749C29.0029 38.5733 28.7642 38.4746 28.5156 38.4746H24.7656ZM43.8613 33.2627C44.1099 33.2628 44.3487 33.3614 44.5244 33.5371C44.7001 33.7129 44.7988 33.9516 44.7988 34.2002C44.7988 34.4487 44.7001 34.6875 44.5244 34.8633C44.3487 35.039 44.1099 35.1376 43.8613 35.1377H36.7109C36.4623 35.1377 36.2236 35.0391 36.0479 34.8633C35.8721 34.6875 35.7734 34.4488 35.7734 34.2002C35.7735 33.9516 35.8721 33.7129 36.0479 33.5371C36.2236 33.3613 36.4623 33.2627 36.7109 33.2627H43.8613ZM24.7656 32.8496C24.517 32.8496 24.2783 32.9483 24.1025 33.124C23.9268 33.2998 23.8282 33.5385 23.8281 33.7871C23.8281 34.0357 23.9268 34.2744 24.1025 34.4502C24.2783 34.626 24.517 34.7246 24.7656 34.7246H28.5156C28.7643 34.7246 29.0029 34.626 29.1787 34.4502C29.3545 34.2744 29.4531 34.0357 29.4531 33.7871C29.4531 33.5385 29.3545 33.2998 29.1787 33.124C29.0029 32.9483 28.7642 32.8496 28.5156 32.8496H24.7656ZM43.2773 26.3135C43.2773 26.3135 44.5273 26.3136 44.5273 27.5635V29.4385C44.5273 29.4385 44.5273 30.6885 43.2773 30.6885H37.29C37.2778 30.6884 36.04 30.6823 36.04 29.4385V27.5635C36.0401 27.5506 36.0466 26.3135 37.29 26.3135H43.2773ZM24.7656 27.2246C24.517 27.2246 24.2783 27.3232 24.1025 27.499C23.9268 27.6748 23.8282 27.9135 23.8281 28.1621C23.8281 28.4107 23.9268 28.6494 24.1025 28.8252C24.2783 29.001 24.517 29.0996 24.7656 29.0996H28.5156C28.7643 29.0996 29.0029 29.001 29.1787 28.8252C29.3545 28.6494 29.4531 28.4107 29.4531 28.1621C29.4531 27.9135 29.3545 27.6748 29.1787 27.499C29.0029 27.3233 28.7642 27.2246 28.5156 27.2246H24.7656Z"
        fill="url(#paint0_linear_797_1458)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_797_1458"
          x1="27.2275"
          y1="27.8577"
          x2="48.9419"
          y2="50.9445"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.88" />
          <stop offset="1" stopColor="#3A3AE8" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EditRubricCategoriesAndCriteriaSection: React.FC<{
  gradingType: RubricGradingType;
  categories: EditableRubricCategoryWithError[];
  possibleTags: string[];
  onCategoryAddTag: (index: number, newTag: string) => void;
  onCategoryRemoveTag: (index: number, tagToRemove: string) => void;
  onCategoryCreate: () => void;
  onCategorySelect: () => void;
  onCategoryStartEdit: (index: number) => void;
  onCategoryDuplicate: (index: number) => void;
  onCategoryDelete: (index: number) => void;
  onCategoryUpdateLabel: (index: number, newLabel: string) => void;
  onCategoryUpdateCriteria: (
    categoryIndex: number,
    criteriaIndex: number,
    newCriteria: string,
  ) => void;
  onCategoryUpdateWeight: (
    categoryIndex: number,
    criteriaIndex: number,
    newWeight: number,
  ) => void;
  onCategoryRemoveCriteria: (
    categoryIndex: number,
    criteriaIndex: number,
  ) => void;
  onCategoryAddCriteria: (categoryIndex: number) => void;
  onCategoryCancel: (index: number) => void;
  onCategorySave: (index: number) => void;
  isReadOnlyMode: boolean;
}> = ({
  gradingType,
  categories,
  onCategoryAddTag,
  onCategoryRemoveTag,
  onCategoryCreate,
  onCategorySelect,
  onCategoryStartEdit,
  onCategoryDuplicate,
  onCategoryDelete,
  possibleTags,
  onCategoryUpdateCriteria,
  onCategoryRemoveCriteria,
  onCategoryUpdateWeight,
  onCategoryAddCriteria,
  onCategoryUpdateLabel,
  onCategorySave,
  onCategoryCancel,
  isReadOnlyMode,
}) => {
  const language = useLanguage();

  return (
    <>
      <EditRubricComposableSection
        heading={language.editRubricCategoriesAndCriteriaSectionHeading({
          gradingType,
        })}
        subHeading={language.editRubricCategoriesAndCriteriaSectionSubHeading({
          gradingType,
        })}
        icon={<EditRubricCategoriesAndCriteriaSectionIcon />}
        onCreate={onCategoryCreate}
        onSelect={onCategorySelect}
        isReadOnlyMode={isReadOnlyMode}
      />
      {categories.map((cat, categoryIndex) => {
        return (
          <React.Fragment key={categoryIndex}>
            {cat.draft && (
              <EditRubricEditCategorySection
                gradingType={gradingType}
                tags={cat.draft.tags}
                onAddTag={(newTag) => onCategoryAddTag(categoryIndex, newTag)}
                onRemoveTag={(tagToRemove) =>
                  onCategoryRemoveTag(categoryIndex, tagToRemove)
                }
                possibleTags={possibleTags}
                criteria={cat.draft.criteria}
                onChangeText={(criteriaIndex, newText) =>
                  onCategoryUpdateCriteria(
                    categoryIndex,
                    criteriaIndex,
                    newText,
                  )
                }
                onChangeWeight={(criteriaIndex, newWeight) =>
                  onCategoryUpdateWeight(
                    categoryIndex,
                    criteriaIndex,
                    newWeight,
                  )
                }
                onAddCriteria={() => onCategoryAddCriteria(categoryIndex)}
                label={cat.draft.label}
                onChangeLabel={(newLabel) =>
                  onCategoryUpdateLabel(categoryIndex, newLabel)
                }
                onCancel={() => onCategoryCancel(categoryIndex)}
                onSave={() => onCategorySave(categoryIndex)}
                onRemoveCriteria={(criteriaIndex) =>
                  onCategoryRemoveCriteria(categoryIndex, criteriaIndex)
                }
                duplicateLabelError={cat.duplicateLabelError}
                duplicateLabelServerError={cat.duplicateLabelServerError}
                requiredLabelError={cat.requiredLabelError}
                requiredCriteriaErrors={cat.requiredCriteriaErrors}
              />
            )}
            {!cat.draft && cat.record && (
              <EditRubricPreviewCategorySection
                criteria={cat.record.criteria.map((crit) => {
                  return {
                    criteria: crit.text,
                    weight: crit.weight,
                  };
                })}
                tags={cat.record.tags}
                label={cat.record.label}
                onEdit={() => onCategoryStartEdit(categoryIndex)}
                onDuplicate={() => onCategoryDuplicate(categoryIndex)}
                onDelete={() => onCategoryDelete(categoryIndex)}
                isReadOnlyMode={isReadOnlyMode}
              />
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};
